import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject, forkJoin, Observable, of, Subject } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { api_base_url } from '../../api/api_url';
import { Destinazione } from '../../interfaces/custom/destinazione';
import { StoreService } from '../store.service';

const jwt_helper = new JwtHelperService();

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  user$: BehaviorSubject<any>;
  constructor(private http: HttpClient, private router: Router, private store: StoreService,
    private route: ActivatedRoute) {
    
    this.user$ = new BehaviorSubject<any>(this.getUser());
    setInterval(this.refreshToken.bind(this), 15 * 60 * 1000);

    this.user$.subscribe(authData => {
      if (this.store.price == 'b2c')
        this.showPrices$.next(true);
      else if (!authData)
        this.showPrices$.next(false);
      else {
        this.haveAccessB2B().pipe(tap(haveAccess => {
          if (!haveAccess) {
            this.showPrices$.next(false);
            this.requestAccessB2B().subscribe();
          }
          else {
            this.showPrices$.next(true);
          }
        })).subscribe();
      }
    });

  }

  showPrices$ : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  loginApi(data) {
    return this.http.post(api_base_url + 'Token/Cliente', data, {
      headers: {
        'x-website': this.store.GetIdentificativo,
        ...this.store.x_canale
      }
    });
  }

  login(data) {
    return this.loginApi(data).pipe(
      tap(user => {
          localStorage.setItem('userdata', JSON.stringify(user));
          if (this.store.price == 'b2b') {
            window.location.reload();
            return;
          }

          this.user$.next(user);
        
          let from = this.route.snapshot.queryParamMap.get('from');
          if (from == 'cart') {
            this.router.navigate(['/shop/cart']);
          }
          else {
            this.router.navigate(['/']);
          }
        /*if (!user['isActive']) {
          localStorage.setItem('emailToConfirm', user['email'])
          this.router.navigate(['/auth/confirm']);
        }
        else {
          localStorage.setItem('userdata', JSON.stringify(user));
          this.user$.next(user);

          let from = this.route.snapshot.queryParamMap.get('from');
          if (from == 'cart') {
            this.router.navigate(['/shop/cart']);
          }
          else {
            this.router.navigate(['/']);
          }

        }*/
      }),
    );
  }

  unblock(password) {
    var id = localStorage.getItem("websiteId")
    return this.http.get(api_base_url + 'sitemanagement/websites/' + id + "/password", {
      params: {
        'password': password
      },
      headers: this.getPublicHeader()
    }).pipe(tap(_ => {
      this.store.unblock();
    }))
  }

  register(data) {
    // /#2za7grq
    let replaceFields = (fields) => {
      for (let f of fields) {
        data[f[1]] = data[f[0]];
        delete data[f[0]];
      }
    }
    
    replaceFields([
      ['codiceFiscale', 'codice_fiscale'],
      ['partitaIva', 'partita_iva'],
      ['ragioneSociale', 'ragione_sociale'],
      ['telnumero', 'telefono']
    ]);

    console.log(data);
    return this.http.post(api_base_url + "Register/Cliente", data);
    
    /*.pipe(tap(user => {
      //localStorage.setItem('emailToConfirm', user['email'])
      //Modifica navigazione in uscita gianmarco 
      //this.router.navigate(['/auth/confirm']);
    }))*/
  }

  loginFromRegister(data){
    return this.loginApi(data).pipe(tap(user => {
      console.log(user);
      localStorage.setItem('userdata', JSON.stringify(user));
      if (this.store.price == 'b2b') {
        window.location.reload();
        return;
      }
        //Serve per salvare il token
      this.user$.next(user);
      let from = this.route.snapshot.queryParamMap.get('from');
      if (from == 'cart') {
        this.router.navigate(['/shop/cart']);
      }
      else {
        this.router.navigate(['/']);
      }
    }))
  }

  confirm(codice) {
    let emailToConfirm = localStorage.getItem('emailToConfirm');
    return this.http.get(api_base_url + "Register", {
      headers: {
        'Email': emailToConfirm
      },
      params: {
        'codiceAccesso': codice
      }
    }).pipe(tap(r => {
      localStorage.setItem('confirmNotification', 'Account confermato. Ora puoi accedere')
      this.router.navigate(['/auth/login']);
    }));
  }

  logout(reload?) {
    localStorage.removeItem('token');
    localStorage.removeItem('userdata');
    localStorage.removeItem('emailToConfirm');

    if (reload) {
      window.location.reload();
    }
    else {
      if (this.user$)
        this.user$.next(null);

      if (this.store.price == 'b2b')
        this.showPrices$.next(false);
    }
  }

  getUser() {
    let data = localStorage.getItem('userdata');
    if (!data)
      return;

    let token = localStorage.getItem('token');
    if (!token)
      return;

    const decodedToken = jwt_helper.decodeToken(token);
    if (jwt_helper.isTokenExpired(token)) {
      this.logout();
      return;
    }

    if (decodedToken.CodCliente == '0' && decodedToken.IdAnagRtc == '0') {
      this.logout(true);
      return;
    }

    try {
      let userdata = JSON.parse(data);
      if (userdata && decodedToken.Email.toLowerCase() == userdata.email.toLowerCase())
        return JSON.parse(data);
      else {
        this.logout();
      }
    } catch (err) {
      this.logout(true);
    }
  }

  isAdminUser() {
    const user = this.getUser();
    if  (!user)
      return false;
    const nomeUnivoco = user.codiceAziendaGestita;
    return this.store.azienda_nome_univoco == nomeUnivoco;
  }

  haveAccessB2B() {
    return this.http.get<any>(api_base_url + 'Azienda/Permission', {
      headers: this.getHeader()
    }).pipe(map<any, boolean>(aziende => {
      return aziende.find(azienda => azienda.nomeUnivoco == this.store.azienda_nome_univoco) ? true : false;
    }));
  }

  requestAccessB2B() {
    return this.http.get<any>(api_base_url + 'Azienda/Permission/add', {
      headers: this.getHeader(),
      params: {
        'name': this.store.azienda_nome_univoco
      }
    }).pipe(catchError(err => of(null)));
  }

  getPublicHeader(): { [header: string]: string } {
    const headers: { [header: string]: string } = {};
    const public_token = localStorage.getItem('public_token');
    if (!public_token) {
      return headers;
    }
    try {
      if (jwt_helper.isTokenExpired(public_token)) {
        location.reload();
        return headers;
      }
    } catch (err) {
      return headers;
    }
    headers['Authorization'] = 'Bearer ' + public_token;
    return headers;
  }

  getHeader(): { [header: string]: string } {
    let user = this.getUser();
    if (!user) {
      return this.getPublicHeader();
    }

    let token = localStorage.getItem('token');
    if (!token)
      return this.getPublicHeader();

    if (jwt_helper.isTokenExpired(token))
      return this.getPublicHeader();

    return {
      'Authorization': 'Bearer ' + token
    }
  }

  getPasswordLost(email) {
    return this.http.get(api_base_url + 'PasswordLost/Cliente', {
      headers: {
        'email': email,
        'x-website': this.store.GetIdentificativo
      }
    });
  }

  setNewPassword(email, codiceAccesso, newPassword) {
    return this.http.get(api_base_url + 'PasswordLost/NewPassword/Cliente', {
      params: {
        'codiceAccesso': codiceAccesso
      },
      headers: {
        'email': email,
        'new_password': newPassword,
        'x-website': this.store.GetIdentificativo
      }
    }).pipe(
      tap(user => {
        this.router.navigate(['/auth/login']);
        localStorage.setItem('passwordReset', 'true');
      })
    );
  }

  isPasswordReset() {
    let passwordReset = localStorage.getItem('passwordReset');
    localStorage.removeItem('passwordReset');
    return passwordReset;
  }

  /*isAccountConfirm() {
    let accountConfirm = localStorage.getItem('confirmNotification');
    localStorage.removeItem('confirmNotification');
    return accountConfirm;
  }*/

  getDestinations(): Observable<Destinazione[]> {
    return this.http.get<Destinazione[]>(api_base_url + 'DestinazioniUtente', {
      headers: this.getHeader()
    });
  }

  getDefaultDestination(destinations: Destinazione[]) {
    for (let dest of destinations)
      if (dest.preferenziale)
        return dest;
    if (destinations && destinations.length)
      return destinations[0];
  }

  salvaDestinazione(destinazione: Destinazione) {
    destinazione.preferenziale = true;
    if (destinazione.codiceDestinazione) {
      return this.http.put<Destinazione>(api_base_url + 'DestinazioniUtente', destinazione, {
        headers: this.getHeader()
      });
    }
    return this.http.post<Destinazione>(api_base_url + 'DestinazioniUtente', destinazione, {
      headers: this.getHeader()
    })
  }

  getOrders(extra_params) {
    return this.http.get(api_base_url + "Documenti", {
      headers: this.getHeader(),
      params: {
        'codice_fiscale_azienda': this.store.identificativo_azienda,
        'tipoDocumento': "CLI-ORDINE",
        'order_by': '<numreg',
        'prezziIvati': this.store.price == 'b2c',
        ...extra_params,
      },
      observe: 'response'
    }).pipe(map(r => {
      let items = r.body || [];
      let totalCount = 0;
      try {
          totalCount = Number(r.headers.get('x-totalcount')) || 0;
      }
      catch (err) { }

      return {
        items: items,
        count: totalCount
      }
    }));
  }

  getOrder(numreg, extra_params) {
    return this.http.get(api_base_url + "Documenti", {
      headers: this.getHeader(),
      params: {
        'codice_fiscale_azienda': this.store.identificativo_azienda,
        'numreg': numreg,
        ...extra_params,
      }
    }).pipe(map(r => r[0]));
  }

  refreshToken() {
    this.http.get(api_base_url + 'CondizioniPagamento', {
      headers: {
        'Business': this.store.azienda_nome_univoco,
        ...this.getHeader()
      }
    }).subscribe();
  }

}
